import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MdsDialogComponent, MdsDialogContentComponent } from '@medpacesoftwaredevelopment/designsystem';
import { TravelRequestStatus } from '@models/request';
import { TravelRequestStatusChangeModalContentComponent } from './travel-request-status-change-modal-content/travel-request-status-change-modal-content.component';
import { TravelRequestStatusChangeFormGroup } from './travel-request-status-change-modal-content/travel-request-status-change-modal-content.form';

export type TravelRequestStatusChangeModalComponentData = {
    requestId: number;
};

export type TravelRequestStatusChangeModalComponentResult = {
    newStatus: string;
    additionalInfo: string;
};

@Component({
    selector: 'medpace-travel-request-status-change-modal',
    imports: [MdsDialogComponent, MdsDialogContentComponent, TravelRequestStatusChangeModalContentComponent],
    templateUrl: './travel-request-status-change-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TravelRequestStatusChangeModalComponent {
    dialogRef = inject<
        MatDialogRef<TravelRequestStatusChangeModalComponent, TravelRequestStatusChangeModalComponentResult>
    >(MatDialogRef<TravelRequestStatusChangeModalComponent, TravelRequestStatusChangeModalComponentResult>);
    data = inject<TravelRequestStatusChangeModalComponentData>(MAT_DIALOG_DATA);

    formGroup = new TravelRequestStatusChangeFormGroup();

    cancel() {
        this.dialogRef.close();
    }
    confirm(formGroup: TravelRequestStatusChangeFormGroup) {
        const value = formGroup.getRawValue();
        this.dialogRef.close({
            newStatus: TravelRequestStatus[value.newStatusId!],
            additionalInfo: value.additionalInfo,
        });
    }
}
